export enum Permissions {
    Add,
    Edit,
    Delete,
    View
}